module.exports = __webpack_public_path__ + "img/2016_alloottees_iloilo.4db43e0c.jpg";